import React, { useEffect } from 'react';
import "react-responsive-modal/styles.css";
import { Modal as ReactModal } from "react-responsive-modal";
import './modal.scss';
import usePrevious from "../usePrevious";
import { storeBerries, lsLoad } from "../utils";
import MaskModal from "../static/maskModal.svg";

export default function StarModal(props) {
  const {levelResult, moves, totalMoves, puzzleNumber} = props;
  let images = ''
  if (levelResult === 3) {
    images = new Array(3).fill(1).map((_, index) => {
      return <img key={index} className="modal-img-stars smilingBerry" src={require("../static/berrySmiling.svg")} alt="img-modal"/>;
    });
  } else if (levelResult === 2) {
    images = new Array(3).fill(1).map((_, index) => {
      return index !== 2 ?
        <img key={index} className="modal-img-stars smilingBerry" src={require("../static/berrySmiling.svg")} alt="img-modal" /> :
        <img key={index} className="modal-img-stars smilingBerry" src={require("../static/emptyBerry.svg")} alt="img-modal" />;
    });
  } else if (levelResult === 1) {
    images = new Array(3).fill(1).map((_, index) => {
      return index === 0 ?
        <img key={index} className="modal-img-stars smilingBerry" src={require("../static/sadBerry.svg")} alt="img-modal" /> :
        <img key={index} className="modal-img-stars smilingBerry" src={require("../static/emptyBerry.svg")} alt="img-modal" />;
    });
  } 

  const {isOpen} = props
  const prevIsOpen = usePrevious(isOpen);
  useEffect(() => {
    if (!prevIsOpen && isOpen) {
      // console.log({puzzleNumber});
      props.levelCompleteSound.play();
      const berriesCollection = lsLoad("berriesCollection");
      if (berriesCollection) {
        berriesCollection[puzzleNumber] = levelResult;
        storeBerries(berriesCollection);
      } else {
        const arr = [];
        arr[puzzleNumber] = levelResult;
        storeBerries(arr);
      }
    }
  })
  useEffect(() => {
    props.pauseGame(isOpen);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])
  
  return (
    <ReactModal
      classNames={{
        overlay: "modal-component-overlay",
        modal: "modal-component-container",
      }}
      center
      open={props.isOpen}
      onClose={() => {}}
      showCloseIcon={false}
      closeOnOverlayClick={false}
    >
      <img alt="bg" className="maskModal" src={MaskModal} />
      {/* <div className="flex center modal-header">
        {levelResult === 3 && 'Amazing!'}
        {levelResult === 2 && 'Good Game!'}
        {levelResult === 1 && "It’s Alright"}
      </div> */}
      <div className="modal-content">

        <div className="flex flex-row berry-result-container">
          {images}
        </div>

        <div className="result-text">
          {levelResult === 3 && 'Wow! You found the best solution!'}
          {levelResult === 2 && 'Keep going!'}
          {levelResult === 1 && 'Ah, you took too many moves'}
        </div>

        <div className="moves-details">
          <div className="mb-6">
            Perfect moves: {totalMoves}
          </div>
          <div className="mb-6">
            Your moves: {moves}
          </div>
        </div>

        {props.content}
      </div>
      <span className="modal-infotext">{props.infoText}</span>
      {props.children}
    </ReactModal>
  );
}
